import { render } from "./alarmAddressSnooze.vue?vue&type=template&id=c084f25c&scoped=true"
import script from "./alarmAddressSnooze.vue?vue&type=script&lang=js"
export * from "./alarmAddressSnooze.vue?vue&type=script&lang=js"

import "./alarmAddressSnooze.vue?vue&type=style&index=0&id=c084f25c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c084f25c"]])

export default __exports__